module.exports = __webpack_public_path__ + "img/qrec_scheme-20-19.c53d934b.png";